import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

/** 用户报表概览：6 个 KPI + 活跃度/漏斗/标签/资产/时效（后端并行聚合 + 5 分钟两级缓存） */
export function userReportOverview(data) {
  return axios.post(`${base.url}/business/userReport/overview`, qs.stringify(data || {}))
}

/** 用户列表分页：1 条驱动分页 + 3 条批量补齐（余额/标签/权限），不做缓存 */
export function userReportList(data) {
  return axios.post(`${base.url}/business/userReport/list`, qs.stringify(data || {}))
}

/** 用户列表导出 xlsx（后端 keyset 游标分批扫描，全量筛选结果） */
export function userReportExport(data) {
  return axios.post(`${base.url}/business/userReport/export`, qs.stringify(data || {}), { responseType: 'blob' })
}
